import { blue, deepOrange, green, grey, orange, purple } from '@mui/material/colors'

import { EPlanName } from '@albacross/types'

export enum EPlanGroup {
  SalesLed = 'sales_led',
  SelfServe = 'self_serve',
  Agency = 'agency',
  NonPaying = 'non_paying',
  Api = 'api',
  Unknown = 'unknown',
}

export type PlanGroupStyle = { label: string; bg: string; text: string; border: string }

// Tinted, not filled: StatusChip owns the solid semantic colours a column over.
export const PLAN_GROUPS: Record<EPlanGroup, PlanGroupStyle> = {
  [EPlanGroup.SalesLed]: { label: 'Sales-led', bg: purple[50], text: purple[800], border: purple[200] },
  [EPlanGroup.SelfServe]: { label: 'Self-serve', bg: blue[50], text: blue[800], border: blue[200] },
  [EPlanGroup.Agency]: { label: 'Agency', bg: green[50], text: green[900], border: green[200] },
  [EPlanGroup.NonPaying]: { label: 'Non-paying', bg: grey[200], text: grey[800], border: grey[400] },
  [EPlanGroup.Api]: { label: 'API', bg: orange[50], text: deepOrange[900], border: orange[200] },
  [EPlanGroup.Unknown]: { label: 'Unknown', bg: grey[200], text: grey[800], border: grey[400] },
}

export const PLAN_GROUP_NAMES: Record<EPlanName, EPlanGroup> = {
  [EPlanName.Pro]: EPlanGroup.SalesLed,
  [EPlanName.Business]: EPlanGroup.SalesLed,
  [EPlanName.Enterprise]: EPlanGroup.SalesLed,
  [EPlanName.SlgStarter]: EPlanGroup.SalesLed,
  [EPlanName.SlgProfessional]: EPlanGroup.SalesLed,
  [EPlanName.SlgOrganisation]: EPlanGroup.SalesLed,
  [EPlanName.Starter]: EPlanGroup.SelfServe,
  [EPlanName.Premium]: EPlanGroup.SelfServe,
  [EPlanName.SelfService]: EPlanGroup.SelfServe,
  [EPlanName.SelfService99]: EPlanGroup.SelfServe,
  [EPlanName.PlgStarter]: EPlanGroup.SelfServe,
  [EPlanName.PlgProfessional]: EPlanGroup.SelfServe,
  [EPlanName.Agency]: EPlanGroup.Agency,
  [EPlanName.Free]: EPlanGroup.NonPaying,
  [EPlanName.FreeUS]: EPlanGroup.NonPaying,
  [EPlanName.TrialEnded]: EPlanGroup.NonPaying,
  [EPlanName.Appsumo]: EPlanGroup.NonPaying,
  [EPlanName.NoAccess]: EPlanGroup.NonPaying,
  [EPlanName.Api]: EPlanGroup.Api,
}

export const planGroup = (name?: string) => PLAN_GROUPS[PLAN_GROUP_NAMES[name as EPlanName] ?? EPlanGroup.Unknown]
